<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
        <wcinput :option="{placeholder:'订单号 / 会员名称 / 会员手机号 / 配送员名称',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column type="expand">
            <template #default="scope">
                <el-table :data="scope.row.goods" stripe="true" empty-text="" class="TTL-table-child">
                    <template v-slot:empty><el-empty description="暂无数据" /></template>
                    <el-table-column label="商品图" align="center">
                        <template #default="tscope">
                            <wcimage :value="tscope.row.goodsthumb" :option="{size:'middle'}" />
                        </template>
                    </el-table-column>   
                    <el-table-column label="商品名称" prop="goodsname" align="center" />
                    <el-table-column label="商品金额" prop="goodsprice" align="center" />
                    <el-table-column label="商品数量" prop="goodsnum" align="center" />
                </el-table>
            </template>
        </el-table-column>
        <el-table-column label="订单号" align="center">
            <template #default="scope">
                <div class="TTL-renewname" @click="$parent.JUMPVIEW({name:'EsOrderDetail',param:scope.row})">{{scope.row.order_sn}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="支付方式" align="center" />
        <el-table-column prop="price" label="订单金额" align="center" />
        <el-table-column prop="buyermembername" label="买家" align="center" />
        <el-table-column prop="salemembername" label="卖家" align="center" />
        <el-table-column prop="shippingmembername" label="外卖员" align="center" />
        <el-table-column prop="statusname" label="订单状态" align="center" />
        <el-table-column prop="inputtime" label="下单时间" align="center" />
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



</template>

<script>
import INTERFACE_MODEL_ORDER from '@/Interface/Es/Order';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'renew',
            param: {
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_ORDER.GET_ORDER_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
                 for(var i in this.list) this.list[i].isshow=this.list[i].isshow==1 ? true : false;
            });
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.TTL-info {display: inline-flex;justify-content: center;}
::v-deep(.TTL-info .TTL-input .el-input__inner) {text-align: center;}
.TTL-renewname {color:#666eeb;cursor: pointer;}
</style>